import { select, put } from 'redux-saga/effects';
import {
  filterUserRoles,
  extractRolesOptions,
} from 'src/app/utils/filter-options';
import {
  SetRolesOptionsFromDrawer,
  SetPristineRolesOptionsFromDrawer,
} from './actions';
import { IRbacRole, IRbacAssignedRole, OptionsType } from './interfaces';
import {
  getAssignedRoles,
  getSelectedProductOptionFromDrawer,
} from './selectors';
import { getAllRoles } from '../common/selectors';

export function* populateRolesSelect(): Generator {
  const allRoles = (yield select(getAllRoles)) as IRbacRole[];
  const assignedRoles = (yield select(getAssignedRoles)) as IRbacAssignedRole[];
  const selectedProductOptionFromDrawer = (yield select(
    getSelectedProductOptionFromDrawer
  )) as OptionsType;
  const filteredRoles = filterUserRoles(
    allRoles,
    assignedRoles,
    selectedProductOptionFromDrawer?.value ?? ''
  );
  const options = extractRolesOptions(filteredRoles);

  yield put(SetRolesOptionsFromDrawer(options));
  yield put(SetPristineRolesOptionsFromDrawer(options));
}
